/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'facebook': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" _fill="#FFF" fill-rule="evenodd" d="M1.733 0h14.534C17.224 0 18 .776 18 1.733v14.534c0 .957-.776 1.733-1.733 1.733H1.733A1.733 1.733 0 010 16.267V1.733C0 .776.776 0 1.733 0zM12.61 7.604V6.45c0-.577.385-.674.577-.674h1.733V3.177h-2.31c-2.6 0-3.177 1.925-3.177 3.08v1.347H7.99v2.984h1.54V18h2.888v-7.412h2.214l.096-1.155.193-1.829h-2.31z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/facebook.js